module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/media/instructions-loop-mobile.2d93bc37.mp4";